import { render, staticRenderFns } from "./tenant-error.vue?vue&type=template&id=6714bbf4&"
import script from "./tenant-error.vue?vue&type=script&lang=js&"
export * from "./tenant-error.vue?vue&type=script&lang=js&"
import style0 from "./tenant-error.vue?vue&type=style&index=0&id=6714bbf4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports